export default "__VITE_ASSET__158dde46__"